import { render } from "./PricingTable.vue?vue&type=template&id=4182a422&lang=pug"
import script from "./PricingTable.vue?vue&type=script&lang=js"
export * from "./PricingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__